import { render, staticRenderFns } from "./DataVolumeByRegion.vue?vue&type=template&id=422b1256&"
import script from "./DataVolumeByRegion.vue?vue&type=script&lang=js&"
export * from "./DataVolumeByRegion.vue?vue&type=script&lang=js&"
import style0 from "./DataVolumeByRegion.vue?vue&type=style&index=0&id=422b1256&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports